// const Backend_Url = "http://localhost:3000/"
// const Backend_Url = "https://tc2.yes-bm.com/api/"
const Backend_Url = "https://www.websitebackend.yes-bm.com/api/"

export default Backend_Url;
